export const sortBy = <T, T2 extends keyof T>(
  sources: T[],
  key?: T2 | ((s: T) => string | number),
  dir: 'asc' | 'desc' = 'asc'
) => {
  if (!sources) return [];
  return sources.sort((a, b) => {
    const valueA = !key
      ? a
      : typeof key === 'function'
        ? key(a)
        : // @ts-ignore
          a[String(key)];
    const valueB = !key
      ? b
      : typeof key === 'function'
        ? key(b)
        : // @ts-ignore
          b[String(key)];
    if (dir === 'desc') return valueA > valueB ? -1 : 1;
    return valueA < valueB ? -1 : 1;
  });
};
